import { Grid } from "@mui/material";
import React from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import PrintIcon from "@mui/icons-material/Print";

export default function GheymatManteghei() {
  return (
    <DashboardLayout>
      <DashboardNavbar name={"قیمت منطقه ای"} />
      <MDBox bgColor="white" borderRadius="5px" p={"10px"}>
        <MDTypography fontSize={"15px"} fontWeight="bold">
          جستجوی قیمت منطقه ای
        </MDTypography>
        <MDDivider />
        <MDBox>
          <Grid container gap="14px 0" textAlign={"center"} my={4}>
            <Grid container item alignItems="center" justifyContent={"center"}>
              <Grid item width="150px">
                <MDTypography fontSize="15px">منطقه</MDTypography>
              </Grid>
              <Grid item flex={1} xs={3}>
                <MDInput
                  fullWidth
                  size="small"
                  width="80px"
                  //   onChange={formik.handleChange}
                  // name="Mantaghe"
                  // value={formik.values.Mantaghe}
                />
              </Grid>
            </Grid>
            <Grid container item alignItems="center" justifyContent={"center"} mt={4} gap="14px 0">
              <Grid item width="150px" xs={2}>
                <MDTypography fontSize="15px">شمال</MDTypography>
              </Grid>
              <Grid item flex={1} xs={4}>
                <MDInput
                  fullWidth
                  size="small"
                  name="Hoze"
                  //  onChange={formik.handleChange}
                  //  value={formik.values.Hoze}
                />
              </Grid>
              <Grid item width="150px" xs={2}>
                <MDTypography fontSize="15px">شرق</MDTypography>
              </Grid>
              <Grid item flex={1} xs={4}>
                <MDInput
                  fullWidth
                  size="small"
                  name="Hoze"
                  //  onChange={formik.handleChange}
                  //  value={formik.values.Hoze}
                />
              </Grid>
              <Grid item width="150px" xs={2}>
                <MDTypography fontSize="15px">جنوب</MDTypography>
              </Grid>
              <Grid item flex={1} xs={4}>
                <MDInput
                  fullWidth
                  size="small"
                  name="Hoze"
                  //  onChange={formik.handleChange}
                  //  value={formik.values.Hoze}
                />
              </Grid>
              <Grid item width="150px" xs={2}>
                <MDTypography fontSize="15px">غرب</MDTypography>
              </Grid>
              <Grid item flex={1} xs={4}>
                <MDInput
                  fullWidth
                  size="small"
                  name="Hoze"
                  //  onChange={formik.handleChange}
                  //  value={formik.values.Hoze}
                />
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
          <MDTypography fontWeight="bold" fontSize="14px">
            مشخصات ملک
          </MDTypography>
          <MDDivider />
          <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={1} border="2px #5b5b5b solid">
            <MDBox bgColor="#eeeeee" px={1}>
              <Grid container columns={10} textAlign="center">
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>منطقه</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>حوزه</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>بلوک</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>نام</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>نام خانوادگی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>کد ملی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>مبلغ نوسازی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>مبلغ پسماند</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>مبلغ کلی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>چاپ</MDTypography>
                </Grid>
              </Grid>
            </MDBox>
            {/* {searched.length > 0 &&
              searched.map((data: any, index: number) => {
                return (
                  <MDBox
                    bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                    px={1}
                    key={uuid()}
                    sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                    textAlign="center"
                  >
                    <Grid container columns={10}>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.melkMalek.mantaghe ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.melkMalek.hoze ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.melkMalek.blook ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.melkMalek.malekName ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.melkMalek.familyName ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.melkMalek.codeMeli ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{((parseFloat(data.mablaghAvarez) * 2) / 3).toFixed(2) ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{(parseFloat(data.mablaghAvarez) / 3).toFixed(2) ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{parseFloat(data.mablaghAvarez).toFixed(2) ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1} textAlign="center">
                        <MDBox onClick={() => window.open(`/webroutes/Nosazi/${data.id}`, "_blank")}>
                          <PrintIcon color="warning" />
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                );
              })} */}
          </MDBox>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}
